import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import eric from "../../assets/images/speakers/eric.png";

function Eric() {
  return (
    <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Maryland, College Park</p>
          <p>Stamp Student Union: Hoff Theatre</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={eric} alt="Eric Huang" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Eric Huang</h1>
      <h2>PhD Candidate</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
        Eric Huang is a PhD candidate in physics at the University of Maryland working under Professor Michael Gullans on quantum error correction and fault tolerance. Their work aims to design useful quantum computers that are resilient against imperfections of the real world.
      </p>
    </div>
    </>
  );
}

export default Eric;